<template>
  <section>
    <ImportBtn
      @onUpload="onUpload"
      :name="buttons.first"
      :btnStyle="btnStyle"
      :btnIcon="btnIcon"
      :btnDisabled="btnDisabled"
    />
    <Dialog
      :header="
        data?.fileError == true
          ? $t('csvImport.headers.listError')
          : data?.errors !== ''
          ? $t('csvImport.headers.errorReport')
          : $t('csvImport.headers.loading')
      "
      v-model:visible="display"
      @hide="display = false"
      :closable="data.errors !== '' || data?.fileError == true"
      :draggable="false"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '40vw' }"
      :modal="true"
      @update:visible="onClose"
    >
      <div
        id="waiting"
        v-if="data.errors == ''"
        class="py-10 flex flex-col justify-center items-center gap-3"
      >
        <v-icon
          name="md-uploadfile-outlined"
          class="text-gray-400"
          :scale="4"
        />
        <p class="font-bold text-md text-h-primary-500">
          {{ data?.file?.name }}
        </p>
        <p v-if="data?.fileError == true" class="text-h-error-400">
          {{ $t("csvImport.fileError") }}
        </p>
        <div v-if="data?.fileError == false">
          <ProgressBar
            mode="indeterminate"
            class="progressbar-style w-60"
            :style="{ height: '0.5em' }"
          />
        </div>
      </div>

      <div id="errors" v-if="data.errors !== ''">
        <p class="text-lg mb-2">{{ $t("csvImport.errors") }}</p>
        <ScrollPanel
          v-if="showErrors"
          :style="{ width: '100%', maxHeight: '400px' }"
        >
          <div v-for="(error, i) in data.errors" :key="i">
            <div
              class="flex items-center font-bold gap-3 my-3 text-sm text-red-400 w-max"
            >
              <div class="flex items-center gap-3">
                <p
                  v-for="(item, index) in Object.keys(error)"
                  :key="index"
                  class="flex gap-3"
                >
                  <small
                    v-if="item !== 'Error'"
                    class="text-black font-bold text-sm md:text-base"
                  >
                    {{
                      $t("labels.generic", {
                        pt: "Linha ",
                        en: "Line ",
                      }).concat(error[item]?.replaceAll('"', " "))
                    }}:
                  </small>
                  <small
                    v-else-if="item == 'Error'"
                    class="bg-red-400 rounded-md p-2 text-white"
                  >
                    {{ service.errorHandler(error[item]) }}
                  </small>
                </p>
              </div>
            </div>
          </div>
        </ScrollPanel>
      </div>

      <template #footer>
        <div
          v-if="data?.csv !== '' || data?.fileError == true"
          class="flex flex-wrap gap-2 justify-center md:justify-end"
        >
          <ImportBtn
            @onUpload="onUpload"
            :name="buttons.second"
            btnStyle="btn-outline"
          />

          <Button
            v-if="data?.fileError == false"
            icon="pi pi-upload"
            label="Baixar relatório"
            class="btn-primary p-button-sm"
            @click="onDownload"
          />
        </div>
      </template>
    </Dialog>
  </section>
</template>

<script lang="ts">
import { UsersService } from "@/views/Users/users.service";
import { defineAsyncComponent, defineComponent, PropType } from "vue";

const ImportBtn = defineAsyncComponent(
  () => import("./Button/import-button.vue")
);

export default defineComponent({
  name: "importCSV",
  components: { ImportBtn },
  emits: ["onUpload", "onDownload", "onClose"],
  props: {
    data: {
      type: Object as PropType<any>,
    },
    openModal: {
      type: Boolean,
    },
    buttons: {
      type: Object as PropType<any>,
      default: { first: "", second: "" },
    },
    btnStyle: {
      type: String,
      default: "btn-primary",
    },
    showErrors: { type: Boolean, default: false },
    btnDisabled: { type: Boolean, default: false },
    btnIcon: { type: String, default: "md-upload" },
  },
  computed: {
    service(): UsersService {
      return new UsersService();
    },
  },
  watch: {
    openModal(val) {
      this.display = val;
    },
  },
  data() {
    return {
      display: this.openModal as boolean,
    };
  },
  methods: {
    onUpload(event: any): void {
      this.display = true;
      this.$emit("onUpload", event);
    },
    onDownload(): void {
      this.$emit("onDownload");
    },
    onClose(): void {
      this.$emit("onClose");
    },
  },
});
</script>
